module.exports = __webpack_public_path__ + "static/media/RP-73.618b8c21.pdf";